/**
 * Inventory Module
 *
 * Handles inventory-specific functionality including stock adjustment modal.
 */

import { $, ready } from '../utils/dom.js';

/**
 * Open the stock adjustment modal
 * @param {string} productId - Product ID
 * @param {string} productType - Product type (product, modifier)
 * @param {string} productName - Product name for display
 * @param {string|number} currentStock - Current stock quantity
 */
export function openAdjustmentModal(productId = '', productType = '', productName = '', currentStock = '') {
    const modal = $('#adjustmentModal');
    if (!modal) return;

    // Set values
    const productIdInput = $('#modal_product_id');
    const productTypeInput = $('#modal_product_type');
    const productNameEl = $('#modal_product_name');
    const currentStockEl = $('#modal_current_stock');

    if (productIdInput) productIdInput.value = productId;
    if (productTypeInput) productTypeInput.value = productType;
    if (productNameEl) productNameEl.textContent = productName;
    if (currentStockEl) currentStockEl.textContent = currentStock;

    modal.classList.remove('hidden');
}

/**
 * Close the stock adjustment modal
 */
export function closeAdjustmentModal() {
    const modal = $('#adjustmentModal');
    if (!modal) return;

    modal.classList.add('hidden');

    // Reset form fields
    const adjustmentType = $('#adjustment_type');
    const quantity = $('#quantity');
    const reason = $('#reason');

    if (adjustmentType) adjustmentType.value = '';
    if (quantity) quantity.value = '';
    if (reason) reason.value = '';
}

/**
 * Initialize modal close on backdrop click
 */
function initModalBackdrop() {
    const modal = $('#adjustmentModal');
    if (!modal) return;

    modal.addEventListener('click', function(e) {
        if (e.target === this) {
            closeAdjustmentModal();
        }
    });
}

/**
 * Filter inventory by category
 * @param {HTMLSelectElement} select - Category select element
 */
export function filterByCategory(select) {
    const category = select.value;
    const params = new URLSearchParams(window.location.search);

    if (category) {
        params.set('category', category);
    } else {
        params.delete('category');
    }

    window.location.href = '/inventory' + (params.toString() ? '?' + params.toString() : '');
}

/**
 * Filter inventory by stock status
 * @param {HTMLSelectElement} select - Status select element
 */
export function filterByStatus(select) {
    const status = select.value;
    const params = new URLSearchParams(window.location.search);

    if (status) {
        params.set('status', status);
    } else {
        params.delete('status');
    }

    window.location.href = '/inventory' + (params.toString() ? '?' + params.toString() : '');
}

/**
 * Clear all inventory filters
 */
export function clearFilters() {
    window.location.href = '/inventory';
}

// Auto-initialize
ready(initModalBackdrop);

// Expose globally for legacy onclick handlers
window.openAdjustmentModal = openAdjustmentModal;
window.closeAdjustmentModal = closeAdjustmentModal;
window.filterByCategory = filterByCategory;
window.filterByStatus = filterByStatus;

export default {
    openAdjustmentModal,
    closeAdjustmentModal,
    filterByCategory,
    filterByStatus,
    clearFilters
};
